(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-reading-bar"] && !Shopify.designMode) return;
  try {
    
  /* The bar reveals its full message on hover, and on tap where there is no
     hover to give. Tapping again puts it back. */
  document.querySelectorAll('.arb').forEach((bar) => {
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (fine) {
      bar.addEventListener('mouseenter', () => bar.classList.add('is-revealed'));
      bar.addEventListener('mouseleave', () => bar.classList.remove('is-revealed'));
      bar.addEventListener('focusin',  () => bar.classList.add('is-revealed'));
      bar.addEventListener('focusout', () => bar.classList.remove('is-revealed'));
      return;
    }

    const ticker = bar.querySelector('.arb__ticker');
    if (!ticker) return;
    ticker.addEventListener('click', (e) => {
      // Never swallow a tap meant for the link inside the message.
      if (e.target.closest('a')) return;
      bar.classList.toggle('is-revealed');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-choices"] && !Shopify.designMode) return;
  try {
    
  class GiftChoices {
    constructor(root) {
      this.root = root;
      this.cards = Array.from(root.querySelectorAll('[data-gcho-open]'));
      this.lb = root.querySelector('[data-gcho-lightbox]');
      this.stage = root.querySelector('[data-gcho-stage]');
      this.dots = root.querySelector('[data-gcho-dots]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.dwell = 5000;

      this.cards.forEach((card) => {
        const frames = Array.from(card.querySelectorAll('img'));
        card._frames = frames;
        card._at = 0;

        if (this.finePointer && !this.reduced && frames.length > 1) {
          card.addEventListener('mouseenter', () => this.play(card));
          card.addEventListener('mouseleave', () => this.stop(card));
          card.addEventListener('focus', () => this.play(card));
          card.addEventListener('blur', () => this.stop(card));
        }
        card.addEventListener('click', () => this.open(frames));
      });

      root.querySelectorAll('[data-gcho-close]').forEach((el) =>
        el.addEventListener('click', () => this.close()));
      root.querySelector('[data-gcho-prev]')?.addEventListener('click', () => this.step(-1));
      root.querySelector('[data-gcho-next]')?.addEventListener('click', () => this.step(1));

      this._onKey = (e) => {
        if (this.lb.hidden) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.step(-1);
        if (e.key === 'ArrowRight') this.step(1);
      };
      document.addEventListener('keydown', this._onKey);
    }

    // ---- hover preview on the card itself ----
    play(card) {
      this.stop(card);
      card._timer = window.setInterval(() => {
        const f = card._frames;
        f[card._at].classList.remove('is-on');
        card._at = (card._at + 1) % f.length;
        f[card._at].classList.add('is-on');
      }, 1100);
    }

    stop(card) {
      window.clearInterval(card._timer);
      const f = card._frames;
      f.forEach((im, i) => im.classList.toggle('is-on', i === 0));
      card._at = 0;
    }

    // ---- image-only lightbox ----
    open(frames) {
      this.frames = frames.map((im) => im.currentSrc || im.src);
      this.index = 0;
      this.stage.innerHTML = '';
      this.dots.innerHTML = '';

      this.frames.forEach((src, i) => {
        const im = new Image();
        im.src = src;
        im.alt = '';
        im.loading = i === 0 ? 'eager' : 'lazy';
        this.stage.appendChild(im);

        const d = document.createElement('button');
        d.className = 'gcho-lb__dot';
        d.type = 'button';
        d.setAttribute('aria-label', 'Image ' + (i + 1));
        d.addEventListener('click', () => this.show(i));
        this.dots.appendChild(d);
      });

      this.lb.hidden = false;
      document.body.style.overflow = 'hidden';
      this.lastFocus = document.activeElement;
      this.root.querySelector('[data-gcho-close]')?.focus();
      this.show(0);
    }

    close() {
      window.clearTimeout(this._advance);
      this.lb.hidden = true;
      document.body.style.overflow = '';
      this.stage.innerHTML = '';
      this.lastFocus?.focus();
    }

    step(dir) {
      this.show((this.index + dir + this.frames.length) % this.frames.length);
    }

    show(i) {
      window.clearTimeout(this._advance);
      this.index = i;
      const imgs = Array.from(this.stage.children);
      imgs.forEach((im, n) => {
        im.classList.remove('is-on');
        if (n === i) {
          // restart the zoom each time the frame becomes current
          void im.offsetWidth;
          im.style.setProperty('--gcho-dwell', this.dwell + 'ms');
          im.classList.add('is-on');
        }
      });
      Array.from(this.dots.children).forEach((d, n) =>
        d.setAttribute('aria-selected', String(n === i)));

      if (!this.reduced && this.frames.length > 1) {
        this._advance = window.setTimeout(() => this.step(1), this.dwell);
      }
    }
  }

  document.querySelectorAll('[data-gcho]').forEach((el) => new GiftChoices(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-feature-gallery"] && !Shopify.designMode) return;
  try {
    
  class GiftCoverflow {
    constructor(root) {
      this.root = root;
      this.rail = root.querySelector('[data-gfg-rail]');
      this.cards = Array.from(root.querySelectorAll('[data-gfg-card]'));
      this.pills = Array.from(root.querySelectorAll('[data-gfg-pill]'));
      if (!this.rail || this.cards.length === 0) return;

      this.loop = this.rail.dataset.gfgLoop === 'true';
      this.count = parseInt(this.rail.dataset.gfgCount, 10) || this.cards.length;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.index = 0;
      this.locked = false;

      this.rail.addEventListener('scroll', () => {
        this.schedule();
        window.clearTimeout(this._idle);
        this._idle = window.setTimeout(() => this.rewind(), 160);
      }, { passive: true });
      window.addEventListener('resize', () => { this.setWidth = 0; this.schedule(); });

      this.pillRail = root.querySelector('[data-gfg-pills]');
      this.pills.forEach((p, i) => p.addEventListener('click', () => this.toIndex(i)));
      root.querySelector('[data-gfg-prev]')?.addEventListener('click', () => this.step(-1));
      root.querySelector('[data-gfg-next]')?.addEventListener('click', () => this.step(1));

      this.rail.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
      });

      this.cards.forEach((c) => c.addEventListener('click', () => {
        if (!c.classList.contains('is-centre')) this.centre(c, true);
      }));

      // Lazy images fire load as they scroll into view. Re-running start()
      // here re-centred the rail on card one, so the carousel kept resetting.
      // Card boxes have a fixed aspect-ratio, so only a re-measure is needed.
      root.querySelectorAll('img').forEach((im) => {
        if (!im.complete) im.addEventListener('load', () => { this.setWidth = 0; this.schedule(); }, { once: true });
      });

      window.requestAnimationFrame(() => this.start());
    }

    // Width of one full set of cards, used for the silent rewind.
    measure() {
      if (this.setWidth) return this.setWidth;
      if (!this.loop) return 0;
      const first = this.cards[0];
      const nextSet = this.cards[this.count];
      this.setWidth = nextSet ? nextSet.offsetLeft - first.offsetLeft : 0;
      return this.setWidth;
    }

    // Open on the middle copy so cards sit on both sides from the first paint.
    start() {
      const target = this.loop ? this.cards[this.count] : this.cards[0];
      if (target) this.centre(target, false);
      this.paint();
    }

    centre(card, smooth) {
      const left = card.offsetLeft - (this.rail.clientWidth - card.offsetWidth) / 2;
      // Suppress the loop rewind until the scroll settles. Shifting scrollLeft
      // mid-animation cancels the smooth scroll, so clicks appeared to do nothing.
      this.animating = true;
      // Mandatory snapping cancels an in-flight programmatic smooth scroll and
      // re-snaps to the card it started from, so stepping appeared to do
      // nothing. Snap is switched off for the duration of the animation.
      this.rail.style.scrollSnapType = 'none';
      window.clearTimeout(this._settle);
      this._settle = window.setTimeout(() => {
        this.animating = false;
        this.pending = null;
        this.rail.style.scrollSnapType = '';
        this.rewind();
      }, 560);
      this.rail.scrollTo({ left, behavior: smooth && !this.reduced ? 'smooth' : 'auto' });
    }

    step(dir) {
      const centred = this.cards.findIndex((c) => c.classList.contains('is-centre'));
      const from = this.animating && this.pending != null
        ? this.pending
        : (centred === -1 ? 0 : centred);
      const target = from + dir;
      const next = this.cards[target];
      if (!next) return;
      this.pending = target;
      this.centre(next, true);
    }

    // Jump to the nearest card carrying this real index, in either direction.
    toIndex(realIndex) {
      const current = this.cards.findIndex((c) => c.classList.contains('is-centre'));
      const from = current === -1 ? 0 : current;
      let best = null;
      let bestDist = Infinity;
      this.cards.forEach((c, i) => {
        if (parseInt(c.dataset.gfgCard, 10) !== realIndex) return;
        const dist = Math.abs(i - from);
        if (dist < bestDist) { bestDist = dist; best = c; }
      });
      if (best) { this.pending = this.cards.indexOf(best); this.centre(best, true); }
    }

    // On phones the pill row scrolls horizontally, so the active label has to
    // travel with the carousel or it drifts out of sight.
    followPill(i) {
      const rail = this.pillRail;
      const pill = this.pills[i];
      if (!rail || !pill) return;
      if (rail.scrollWidth <= rail.clientWidth + 1) return;
      const left = pill.offsetLeft - (rail.clientWidth - pill.offsetWidth) / 2;
      rail.scrollTo({
        left: Math.max(0, left),
        behavior: this.reduced ? 'auto' : 'smooth',
      });
    }

    schedule() {
      window.cancelAnimationFrame(this._raf);
      this._raf = window.requestAnimationFrame(() => this.paint());
    }

    rewind() {
      if (!this.loop || this.locked || this.animating) return;
      // Only ever shift when the rail is genuinely at rest.
      if (this._lastX !== undefined && Math.abs(this.rail.scrollLeft - this._lastX) > 0.5) {
        this._lastX = this.rail.scrollLeft;
        window.clearTimeout(this._idle);
        this._idle = window.setTimeout(() => this.rewind(), 160);
        return;
      }
      this._lastX = this.rail.scrollLeft;
      const setW = this.measure();
      if (!setW) return;
      const x = this.rail.scrollLeft;
      let shift = 0;
      // Hysteresis matters: with symmetric 0.5/1.5 thresholds a downward shift
      // landed exactly on the upward trigger and the rail ping-ponged, so
      // stepping never made progress. Landings now sit well inside the band.
      if (x < setW * 0.25) shift = setW;
      else if (x > setW * 1.75) shift = -setW;
      if (!shift) return;
      this.locked = true;
      const prev = this.rail.style.scrollBehavior;
      this.rail.style.scrollBehavior = 'auto';
      this.rail.scrollLeft = x + shift;
      this.rail.style.scrollBehavior = prev;
      window.requestAnimationFrame(() => { this.locked = false; });
    }

    paint() {
      const railRect = this.rail.getBoundingClientRect();
      const centre = railRect.left + railRect.width / 2;
      let best = null;
      let bestDist = Infinity;

      this.cards.forEach((card) => {
        const r = card.getBoundingClientRect();
        const cardCentre = r.left + r.width / 2;
        const raw = Math.abs(cardCentre - centre);
        const d = Math.min(raw / (r.width || 1), 1.6);
        card.style.setProperty('--d', d.toFixed(3));
        card.style.zIndex = String(100 - Math.round(d * 20));
        card.classList.remove('is-centre');
        if (raw < bestDist) { bestDist = raw; best = card; }
      });

      if (best) {
        best.classList.add('is-centre');
        const real = parseInt(best.dataset.gfgCard, 10);
        if (real !== this.index) {
          this.index = real;
          this.pills.forEach((p, i) => p.setAttribute('aria-selected', String(i === real)));
          this.followPill(real);
        }
      }

    }
  }

  document.querySelectorAll('[data-gfg]').forEach((el) => new GiftCoverflow(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-hero"] && !Shopify.designMode) return;
  try {
    
  class GiftHero {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-gh-viewport]');
      this.slides = Array.from(root.querySelectorAll('[data-gh-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-gh-dot]'));
      this.index = 0;
      if (this.slides.length < 2) return;

      root.querySelector('[data-gh-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      root.querySelector('[data-gh-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

      this.viewport.addEventListener('scroll', () => {
        window.clearTimeout(this._t);
        this._t = window.setTimeout(() => this.sync(), 90);
      }, { passive: true });

      this.viewport.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
      });

      // Keep the active slide aligned when the viewport is resized or rotated.
      let raf;
      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(() => this.snap(false));
      });

      this.startAutoplay();
    }

    snap(smooth = true) {
      const slide = this.slides[this.index];
      if (!slide) return;
      this.viewport.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    go(i) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.snap(true);
      this.paint();
    }

    sync() {
      const i = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
      if (i !== this.index && this.slides[i]) { this.index = i; this.paint(); }
    }

    paint() {
      this.dots.forEach((d, i) => d.setAttribute('aria-selected', String(i === this.index)));
    }

    startAutoplay() {
      if (this.root.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const ms = (parseFloat(this.root.dataset.autoplaySeconds) || 7) * 1000;
      const tick = () => { this._auto = window.setTimeout(() => { this.go(this.index + 1); tick(); }, ms); };
      const stop = () => window.clearTimeout(this._auto);
      tick();
      this.root.addEventListener('mouseenter', stop);
      this.root.addEventListener('focusin', stop);
      this.root.addEventListener('mouseleave', tick);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : tick()));
    }
  }

  document.querySelectorAll('[data-gift-hero]').forEach((el) => new GiftHero(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-interactive"] && !Shopify.designMode) return;
  try {
    
  // The flipbook is a third-party page with its own scripts and chat widget.
  // It is only injected once the visitor asks for it, so it costs nothing on
  // first paint and nothing is loaded from that domain until then.
  document.querySelectorAll('[data-gint-embed]').forEach((frame) => {
    const url = frame.dataset.gintUrl;
    const title = frame.dataset.gintTitle || 'Interactive book';
    if (!url) return;

    const mount = () => {
      if (frame.querySelector('iframe')) return;
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.title = title;
      iframe.setAttribute('allowfullscreen', 'true');
      iframe.setAttribute('scrolling', 'no');
      iframe.setAttribute('loading', 'lazy');
      frame.appendChild(iframe);
      frame.querySelector('[data-gint-open]')?.remove();
    };

    if (frame.dataset.gintMode === 'always') {
      mount();
      return;
    }
    frame.querySelector('[data-gint-open]')?.addEventListener('click', mount);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-landing"] && !Shopify.designMode) return;
  try {
    
  /* Landing carousel.

     Timing follows Vince's sequence exactly: hold, pull back, come forward,
     hold. The outgoing slide and the incoming one each get the fade duration,
     so one full step is hold + fade + fade. */
  class GiftLandingCarousel {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-glc-slide]'));
      if (this.slides.length < 1) return;

      this.i = 0;
      this.hold = parseInt(root.dataset.hold, 10) || 2000;
      this.firstHold = parseInt(root.dataset.firstHold, 10) || this.hold;
      this.firstRun = true;
      this.fade = parseInt(root.dataset.fade, 10) || 500;
      root.style.setProperty('--glc-slide', this.fade + 'ms');

      this.section = root.closest('section');
      this.viewer = this.section.querySelector('[data-glc-viewer]');
      this.vstage = this.section.querySelector('[data-glc-vstage]');
      this.vcount = this.section.querySelector('[data-glc-vcount]');

      root.querySelector('[data-glc-prev]')?.addEventListener('click', () => this.manual(-1));
      root.querySelector('[data-glc-next]')?.addEventListener('click', () => this.manual(1));
      this.slides.forEach((sl) => sl.addEventListener('click', () => this.openViewer(this.slides.indexOf(sl))));

      this.track = root.querySelector('[data-glc-track]');
      this.shuffle();
      this.slides = Array.from(this.track.querySelectorAll('[data-glc-slide]'));
      this.bindViewer();

      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });

      if (this.slides.length > 1) this.start();
    }












    /* No clones and no running index: the strip always shows its first child.
       To advance it slides one frame left, then the first child is moved to the
       end and the strip is snapped back with the transition off — the image on
       screen does not change at that instant, so the move is invisible. There is
       no end of the list to wrap around, which is what kept sticking. */
    /* The order is randomised on every visit, and dealt so that two images of
       the same subject never land next to each other — otherwise a run of seven
       monkeys plays back to back, which is what Vince saw. */
    shuffle() {
      if (!this.track || this.slides.length < 3) return;

      const groups = new Map();
      this.slides.forEach((sl) => {
        const file = (sl.querySelector('img')?.getAttribute('src') || '').split('/').pop().split('?')[0];
        const subject = file.split('-')[0] || 'other';
        if (!groups.has(subject)) groups.set(subject, []);
        groups.get(subject).push(sl);
      });

      const lists = Array.from(groups.values());
      lists.forEach((list) => {
        for (let i = list.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [list[i], list[j]] = [list[j], list[i]];
        }
      });

      const order = [];
      let last = null;
      while (lists.some((l) => l.length)) {
        const pick = lists
          .filter((l) => l.length && l !== last)
          .sort((a, b) => b.length - a.length)[0]
          || lists.find((l) => l.length);
        order.push(pick.shift());
        last = pick;
      }

      order.forEach((sl) => this.track.appendChild(sl));

      /* The approved landing image always shows first on load. The shuffle
         still randomises everything after it, so the gallery stays varied
         without the homepage ever opening on a different picture. */
      const basename = (v) => (v || '').split('/').pop().split('?')[0];
      /* The setting takes a bare filename, but a full CDN URL can be pasted in
         from the media library. Compare basenames so either form matches. */
      const firstName = basename((this.root.dataset.firstAsset || '').trim());
      if (firstName) {
        const pinned = Array.from(this.track.children).find(
          (sl) => basename(sl.querySelector('img')?.getAttribute('src')) === firstName
        );
        if (pinned) this.track.insertBefore(pinned, this.track.firstElementChild);
      }
    }

    step(dir) {
      if (this.moving || !this.track || this.track.children.length < 2) return;
      this.moving = true;
      const settle = () => {
        this.track.style.transition = 'none';
        if (dir > 0) this.track.appendChild(this.track.firstElementChild);
        this.track.style.transform = 'translate3d(0, 0, 0)';
        void this.track.offsetWidth;
        this.track.style.transition = '';
        this.moving = false;
        this.start();
      };

      if (dir > 0) {
        this.track.style.transform = 'translate3d(-100%, 0, 0)';
        this.after(settle);
      } else {
        // going back: bring the last frame round to the front first, off-screen
        this.track.style.transition = 'none';
        this.track.insertBefore(this.track.lastElementChild, this.track.firstElementChild);
        this.track.style.transform = 'translate3d(-100%, 0, 0)';
        void this.track.offsetWidth;
        this.track.style.transition = '';
        this.track.style.transform = 'translate3d(0, 0, 0)';
        this.after(() => { this.moving = false; this.start(); });
      }
    }

    /* transitionend is missed if the tab hides mid-slide, so it is backed up. */
    after(fn) {
      let done = false;
      const run = () => {
        if (done) return;
        done = true;
        this.track.removeEventListener('transitionend', run);
        fn();
      };
      this.track.addEventListener('transitionend', run);
      window.setTimeout(run, this.fade + 300);
    }

    start() {
      this.stop();
      if (this.track.children.length < 2 || this.viewerOpen) return;
      /* The approved hero sits longer on a fresh load so it is actually read
         before anything moves. Every slide after it, including on later loops,
         uses the normal interval. */
      const wait = this.firstRun ? this.firstHold : this.hold;
      this.firstRun = false;
      this.timer = window.setTimeout(() => this.step(1), wait);
    }

    stop() { window.clearTimeout(this.timer); }

    manual(dir) { this.stop(); this.step(dir); }

    /* ---- Fullscreen viewer: no timers, no zoom, no drift ---- */
    bindViewer() {
      if (!this.viewer) return;
      this.section.querySelector('[data-glc-close]')?.addEventListener('click', () => this.closeViewer());
      this.section.querySelector('[data-glc-vprev]')?.addEventListener('click', () => this.paint(this.vi - 1));
      this.section.querySelector('[data-glc-vnext]')?.addEventListener('click', () => this.paint(this.vi + 1));

      this.viewer.addEventListener('click', (e) => {
        if (e.target === this.viewer || e.target === this.vstage) this.closeViewer();
      });

      document.addEventListener('keydown', (e) => {
        if (!this.viewerOpen) return;
        if (e.key === 'Escape') this.closeViewer();
        if (e.key === 'ArrowLeft') this.paint(this.vi - 1);
        if (e.key === 'ArrowRight') this.paint(this.vi + 1);
      });

      let x0 = null;
      this.viewer.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      this.viewer.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) this.paint(this.vi + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    openViewer(i) {
      if (!this.viewer) return;
      this.stop();
      this.viewerOpen = true;
      this.opener = this.slides[i];
      this.viewer.hidden = false;
      document.body.style.overflow = 'hidden';
      this.paint(i);
      this.section.querySelector('[data-glc-close]')?.focus();
    }

    paint(i) {
      const n = this.slides.length;
      this.vi = ((i % n) + n) % n;
      const src = this.slides[this.vi].querySelector('img')?.getAttribute('src') || '';
      this.vstage.innerHTML = '';
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.decoding = 'async';
      this.vstage.appendChild(img);
      if (this.vcount) this.vcount.textContent = (this.vi + 1) + ' / ' + n;
    }

    closeViewer() {
      this.viewerOpen = false;
      this.viewer.hidden = true;
      this.vstage.innerHTML = '';
      document.body.style.overflow = '';
      this.opener?.focus();
      this.start();
    }
  }

  document.querySelectorAll('[data-glc]').forEach((el) => new GiftLandingCarousel(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-offer"] && !Shopify.designMode) return;
  try {
    
  class GiftPersonalize {
    constructor(form) {
      this.form = form;
      this.$ = (sel) => form.querySelector(sel);
      this.panel = form.closest('.gift-offer__form') || document;
      this.preview = this.panel.querySelector('[data-gp-preview]');

      this.bookName = this.$('[data-gift-booking-name]');
      this.formError = this.$('[data-gift-formerror]');

      // Total reflects the optional add-on as soon as it is ticked.
      // The page shows the price in more than one place (product summary and
      // the form total), so every instance has to move together.
      this.totals = Array.from(document.querySelectorAll('[data-gift-total]'));
      this.addonBox = form.querySelector('input[name="items[1][id]"]');
      if (this.totals.length && this.addonBox) {
        const money = (cents) => '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
        const paint = () => {
          const on = this.addonBox.checked;
          this.totals.forEach((el) => {
            const base = parseInt(el.dataset.baseCents, 10) || 0;
            const addon = parseInt(el.dataset.addonCents, 10) || 0;
            el.textContent = money(base + (on ? addon : 0));
            el.classList.toggle('is-bumped', on);
          });
        };
        this.addonBox.addEventListener('change', paint);
        paint();
      }

      form.giftPersonalize = this;
      const submit = this.$('[data-gift-submit]');
      if (submit) submit.dataset.label = submit.textContent.trim();

      this.bindEditables();

      form.addEventListener('input', () => this.update());
      form.addEventListener('change', () => this.update());
      form.addEventListener('submit', (e) => this.onSubmit(e));
      this.update();
    }

    /* innerText rather than textContent: the message is allowed line breaks,
       and textContent flattens them away. */
    static read(el) {
      return (el.innerText || '')
        .replace(/ /g, ' ')
        .replace(/\r/g, '')
        .replace(/\n{3,}/g, '\n\n')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/^\s+|\s+$/g, '');
    }

    bindEditables() {
      const scope = this.preview || this.panel;
      this.edits = Array.from(scope.querySelectorAll('[data-gp-edit]'));

      this.edits.forEach((el) => {
        const max = parseInt(el.dataset.max, 10) || 0;
        const multiline = el.dataset.multiline === 'true';

        // plaintext-only is not in every browser yet. Where it is missing the
        // element silently falls back to rich editing, so paste is intercepted
        // below in every case and markup never gets in.
        if (el.contentEditable !== 'plaintext-only') el.setAttribute('contenteditable', 'true');

        // Stop typing at the limit instead of truncating afterwards, which
        // would throw the caret back to the start of the field mid-sentence.
        el.addEventListener('beforeinput', (e) => {
          if (!max) return;
          if (e.inputType.startsWith('delete')) return;
          if (!multiline && e.inputType === 'insertParagraph') { e.preventDefault(); return; }

          let adding = 0;
          if (e.data) adding = e.data.length;
          else if (e.inputType === 'insertParagraph' || e.inputType === 'insertLineBreak') adding = 1;
          if (!adding) return;

          const sel = window.getSelection();
          const replacing = sel && !sel.isCollapsed ? String(sel).length : 0;
          if (GiftPersonalize.read(el).length - replacing + adding > max) e.preventDefault();
        });

        el.addEventListener('paste', (e) => {
          e.preventDefault();
          const raw = (e.clipboardData || window.clipboardData).getData('text/plain') || '';
          const flat = multiline ? raw.replace(/\r\n?/g, '\n') : raw.replace(/\s+/g, ' ');
          const room = max ? Math.max(0, max - GiftPersonalize.read(el).length) : flat.length;
          if (room) document.execCommand('insertText', false, flat.slice(0, room));
        });

        el.addEventListener('input', () => this.update());
        el.addEventListener('blur', () => this.update());

        // A click anywhere on the card should land the caret in the message,
        // not force the buyer to hit the exact line of text.
        const card = el.closest('.gpv__card');
        if (card && el.classList.contains('gpv__card-msg') && !card.dataset.gpBound) {
          card.dataset.gpBound = '1';
          card.addEventListener('mousedown', (e) => {
            if (e.target.closest('[data-gp-edit]')) return;
            e.preventDefault();
            el.focus();
            const r = document.createRange();
            r.selectNodeContents(el);
            r.collapse(false);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(r);
          });
        }
      });
    }

    /* A long message has to stay inside the illustrated border, and clipping
       it would hide words the buyer had already written. The writing shrinks
       to fit instead, the way it would on a real card. */
    fitCard() {
      const box = this.preview?.querySelector('.gpv__card--art .gpv__card-text');
      if (!box) return;
      const kids = Array.from(box.children);
      if (!kids.length) return;
      const gap = parseFloat(getComputedStyle(box).rowGap) || 0;
      const needed = () =>
        kids.reduce((h, el) => h + el.getBoundingClientRect().height, 0) + gap * (kids.length - 1);

      let fit = 1;
      box.style.setProperty('--gpv-fit', '1');
      // 0.6 is the floor: below that the handwriting stops being readable and
      // the honest answer is a shorter message, not smaller type.
      while (fit > 0.6 && needed() > box.clientHeight) {
        fit -= 0.04;
        box.style.setProperty('--gpv-fit', fit.toFixed(2));
      }
      box.classList.toggle('is-overfull', needed() > box.clientHeight);
    }

    /* The name has to stay on the same line as "For" — that is the whole point
       of writing it there — and the blank strip of paper is only so wide, so
       long names are written smaller rather than running onto the table.

       The width is measured with a Range over the contents. scrollWidth cannot
       be used here: the box lets its text overflow visibly, and in that case
       browsers report scrollWidth as equal to clientWidth, so no amount of
       overflow is ever detectable. */
    fitName() {
      const nm = this.preview?.querySelector('.gpv__name');
      if (!nm || !nm.clientWidth) return;

      nm.style.setProperty('--gpv-name-fit', '1');
      const range = document.createRange();
      range.selectNodeContents(nm);
      let natural = range.getBoundingClientRect().width;
      range.detach?.();
      if (!natural) return;

      // getBoundingClientRect reports visual pixels while clientWidth reports
      // layout pixels, so a scaled ancestor (the theme editor zoom, say) would
      // otherwise shrink the name to nothing.
      const scale = nm.getBoundingClientRect().width / (nm.offsetWidth || 1);
      if (scale > 0 && Math.abs(scale - 1) > 0.01) natural /= scale;

      // The line is tilted, so its bounding box is a little wider than the
      // text itself; the tolerance keeps that from shrinking a name that fits.
      const fit = Math.min(1, Math.max(0.42, (nm.clientWidth + 2) / natural));
      nm.style.setProperty('--gpv-name-fit', fit.toFixed(3));
    }

    valueOf(key) {
      const el = this.edits.find((e) => e.dataset.gpEdit === key);
      return el ? GiftPersonalize.read(el) : '';
    }

    update() {
      // Mirror what has been written onto the artwork into the hidden fields
      // that actually travel to the order.
      this.edits.forEach((el) => {
        const key = el.dataset.gpEdit;
        let text = GiftPersonalize.read(el);

        // beforeinput stops ordinary typing and pasting at the limit. Dropped
        // text and some dictation engines do not raise a cancellable event, so
        // anything that got past it is trimmed here and the caret sent to the
        // end rather than being left mid-string.
        const cap = parseInt(el.dataset.max, 10) || 0;
        if (cap && text.length > cap) {
          text = text.slice(0, cap);
          el.textContent = text;
          if (document.activeElement === el) {
            const r = document.createRange();
            r.selectNodeContents(el);
            r.collapse(false);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(r);
          }
        }

        el.classList.toggle('is-empty', text === '');
        const target = this.form.querySelector(`[data-gift-${key}]`);
        if (target) target.value = text;
      });

      const first = this.valueOf('name');
      if (this.bookName) this.bookName.value = first;

      if (this.count) {
        const msgEl = this.edits.find((e) => e.dataset.gpEdit === 'message');
        const max = msgEl ? parseInt(msgEl.dataset.max, 10) || 0 : 0;
        const n = this.valueOf('message').length;
        if (this.countWrap) this.countWrap.classList.toggle('is-max', max > 0 && n >= max);
      }

      if (this.fitFrame) cancelAnimationFrame(this.fitFrame);
      this.fitFrame = requestAnimationFrame(() => { this.fitName(); this.fitCard(); });

    }

    /* The signature usually reads "Love, Grammy & Grandpa". That is right on a
       card and wrong inside a sentence, so the salutation comes off first. */
    senderName() {
      return this.valueOf('from')
        .replace(/^(love|lots of love|from|with love|xo+|hugs|love always)\b[,\s]*/i, '')
        .replace(/[.!]+$/, '')
        .trim();
    }

    flag(key, msg) {
      const el = this.edits.find((e) => e.dataset.gpEdit === key);
      if (el) {
        el.classList.toggle('is-invalid', !!msg);
        el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      }
      return { ok: !msg, el, msg };
    }

    onSubmit(e) {
      const checks = [
        this.flag('name', this.valueOf('name') ? '' : 'Please write the child’s name on the book.'),
        this.flag('message', this.valueOf('message') ? '' : 'Please write your message on the gift card.'),
      ];

      const bad = checks.find((c) => !c.ok);
      if (bad) {
        e.preventDefault();
        this.formError.textContent = bad.msg;
        this.formError.hidden = false;
        if (bad.el) {
          bad.el.scrollIntoView({ block: 'center', behavior: 'smooth' });
          window.setTimeout(() => bad.el.focus(), 320);
        }
        return;
      }
      this.formError.hidden = true;

      // This is a one-gift-per-order flow, but the cart persists between
      // visits. Posting the form straight to /cart/add would stack a second
      // gift on top of one personalized earlier — which is what was reaching
      // checkout. Any earlier copy of these variants is dropped first, and
      // anything else the buyer is carrying is left alone.
      e.preventDefault();
      this.send();
    }

    async send() {
      const btn = this.$('[data-gift-submit]');
      if (this.sending) return;
      this.sending = true;
      const label = btn ? btn.dataset.label || btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.busy || 'ONE MOMENT…'; }

      const restore = (msg) => {
        this.sending = false;
        if (btn) { btn.disabled = false; btn.textContent = label; }
        this.formError.textContent = msg;
        this.formError.hidden = false;
      };

      try {
        // Every variant this form can add is zeroed, ticked or not. Clearing
        // only the ticked ones would leave a Care & Repair line behind when a
        // buyer comes back from checkout and unticks it — charging them for
        // something they had just declined.
        const updates = {};
        this.form.querySelectorAll('input[name$="[id]"]').forEach((i) => {
          if (i.value) updates[i.value] = 0;
        });

        const post = (url, body) =>
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });

        // The clear has to succeed before adding. Letting it through on failure
        // would risk charging for two gifts, so a transient hiccup is retried
        // once and otherwise stops with a message the buyer can act on.
        let cleared = await post(this.form.dataset.cartUpdate + '.js', { updates });
        if (!cleared.ok) {
          await new Promise((r) => setTimeout(r, 900));
          cleared = await post(this.form.dataset.cartUpdate + '.js', { updates });
        }
        if (!cleared.ok) throw new Error(cleared.status === 429 ? 'busy' : 'cart');

        const added = await fetch(this.form.dataset.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        if (!added.ok) {
          if (added.status === 429) throw new Error('busy');
          const err = await added.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Sorry, we could not start your order.');
        }

        window.location.href = this.form.dataset.checkout;
      } catch (err) {
        const reasons = {
          busy: 'The store is busy right now. Please wait a moment and try again — nothing has been charged.',
          cart: 'Sorry, we could not start your order. Please try again.',
        };
        restore(reasons[err.message] || err.message);
      }
    }
  }

  document.querySelectorAll('[data-gift-form]').forEach((f) => new GiftPersonalize(f));

  // Returning from checkout with the back button restores this page from the
  // bfcache exactly as it was left: mid-submit, with the button disabled and
  // still reading "one moment". Nothing re-runs on its own, so the submit
  // state is released by hand.
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('[data-gift-form]').forEach((f) => {
      const btn = f.querySelector('[data-gift-submit]');
      if (btn && btn.disabled) {
        btn.disabled = false;
        if (btn.dataset.label) btn.textContent = btn.dataset.label;
      }
      const err = f.querySelector('[data-gift-formerror]');
      if (err) err.hidden = true;
      if (f.giftPersonalize) f.giftPersonalize.sending = false;
    });
  });

  // Any CTA pointing at the form opens it, scrolls to it and focuses the first
  // field, so the collapsed state never becomes a dead end.
  (function () {
    const wrap = document.querySelector('[data-gift-collapse]');
    if (!wrap) return;
    const panel = wrap.closest('.gift-offer__form');
    const anchorId = panel ? panel.id : 'gift-personalize';

    function open(focus) {
      if (!wrap.open) wrap.open = true;
      if (focus) {
        window.requestAnimationFrame(() => {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const first = wrap.querySelector('[data-gp-edit], input:not([type=hidden]), select, textarea');
          if (first) window.setTimeout(() => first.focus({ preventScroll: true }), 320);
        });
      }
    }

    document.querySelectorAll(`a[href$="#${anchorId}"]`).forEach((a) => {
      a.addEventListener('click', (e) => { e.preventDefault(); open(true); history.replaceState(null, '', `#${anchorId}`); });
    });

    if (location.hash === `#${anchorId}`) open(true);

    // Clicking the trigger directly also needs to bring the form into view,
    // otherwise it expands below the fold and looks like nothing happened.
    wrap.addEventListener('toggle', () => {
      if (!wrap.open) return;
      window.requestAnimationFrame(() => {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const first = wrap.querySelector('[data-gp-edit], input:not([type=hidden]), select, textarea');
        if (first) window.setTimeout(() => first.focus({ preventScroll: true }), 340);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-personalize"] && !Shopify.designMode) return;
  try {
    
  class GiftPersonalizer {
    constructor(form) {
      this.form = form;
      this.names = form.querySelector('[data-gper-names]');
      this.addon = form.querySelector('[data-gper-addon]');
      this.totalEl = form.querySelector('[data-gper-total]');
      this.errEl = form.querySelector('[data-gper-err]');
      this.formError = form.querySelector('[data-gper-formerror]');
      this.submit = form.querySelector('[data-gper-submit]');

      const scope = form.closest('.gper') || document;
      this.preview = scope.querySelector('[data-gper-preview]');
      this.book = scope.querySelector('.gper__book');
      this.emptyText = this.preview ? this.preview.textContent.trim() : '';

      this.giftCents = parseInt(form.dataset.giftCents, 10) || 0;
      this.addonCents = parseInt(form.dataset.addonCents, 10) || 0;

      form.addEventListener('input', () => this.update());
      form.addEventListener('change', () => this.update());
      form.addEventListener('submit', (e) => { e.preventDefault(); this.send(); });

      this.update();
    }

    static money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    update() {
      const typed = (this.names.value || '').trim();

      /* The inscription reads back exactly what will be written in the book. */
      if (this.preview) {
        this.preview.textContent = typed || this.emptyText;
        this.preview.classList.toggle('is-empty', !typed);
        this.fit();
      }

      /* Ticking the add-on must never disturb what has been typed, so the
         total is recalculated rather than the form being re-rendered. */
      const on = this.addon && this.addon.checked;
      this.totalEl.textContent = GiftPersonalizer.money(this.giftCents + (on ? this.addonCents : 0));

      if (typed) {
        this.names.setAttribute('aria-invalid', 'false');
        this.errEl.hidden = true;
      }
    }

    /* Long names shrink rather than running off the page. */
    fit() {
      if (!this.book || !this.preview) return;
      const room = this.preview.parentElement.clientWidth;
      if (!room) return;
      this.book.style.setProperty('--gper-fit', '1');
      let fit = 1;
      while (fit > 0.45 && this.preview.scrollWidth > room) {
        fit -= 0.05;
        this.book.style.setProperty('--gper-fit', fit.toFixed(2));
      }
    }

    async send() {
      if (this.sending) return;

      const typed = (this.names.value || '').trim();


      this.sending = true;
      const label = this.submit.textContent;
      this.submit.disabled = true;
      this.submit.textContent = 'One moment…';
      this.formError.hidden = true;

      const giftId = Number(this.form.dataset.giftVariant);
      const addonId = this.form.dataset.addonVariant ? Number(this.form.dataset.addonVariant) : null;
      const wantsAddon = this.addon && this.addon.checked;

      const items = [{ id: giftId, quantity: 1, properties: typed ? { 'Inscription Name(s)': typed } : {} }];
      if (wantsAddon && addonId) items.push({ id: addonId, quantity: 1 });

      try {
        /* Clearing first means coming back to edit cannot leave a duplicate
           gift or a stale add-on behind. */
        const updates = {};
        updates[giftId] = 0;
        if (addonId) updates[addonId] = 0;

        await fetch(this.form.dataset.cartUpdate + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });

        const added = await fetch(this.form.dataset.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!added.ok) {
          const err = await added.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Sorry, we could not start your order.');
        }

        window.location.href = this.form.dataset.checkout;
      } catch (err) {
        this.sending = false;
        this.submit.disabled = false;
        this.submit.textContent = label;
        this.formError.textContent = err.message;
        this.formError.hidden = false;
      }
    }
  }

  document.querySelectorAll('[data-gper-form]').forEach((f) => new GiftPersonalizer(f));

  /* Coming back from checkout restores this page mid-submit. */
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('[data-gper-submit]').forEach((b) => {
      if (b.disabled) window.location.reload();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-reviews"] && !Shopify.designMode) return;
  try {
    
  class GiftReviews {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-rev-track]');
      this.sets = root.querySelectorAll('.rev__set');
      if (!this.track || !this.sets.length) return;

      this.speed = parseFloat(root.dataset.speed) || 30;
      this.coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;

      this.measure();
      window.addEventListener('resize', () => this.measure());
      // Images arrive after first paint, so the width has to be taken again.
      root.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.measure(), { once: true });
      });

      this.bind();
    }

    // Duration follows the measured width, so the reviews travel at the same
    // speed however many of them there are.
    measure() {
      const w = this.sets[0].getBoundingClientRect().width;
      if (!w) return;
      this.track.style.setProperty('--rev-dur', (w / this.speed).toFixed(2) + 's');
    }

    lift(item) {
      if (this.held && this.held !== item) this.held.classList.remove('is-lifted');
      this.held = item;
      if (item) item.classList.add('is-lifted');
      this.root.classList.toggle('is-paused', !!item);
    }

    drop() {
      if (this.held) this.held.classList.remove('is-lifted');
      this.held = null;
      this.root.classList.remove('is-paused');
    }

    bind() {
      const items = this.root.querySelectorAll('[data-rev-item]');

      if (this.coarse) {
        // No hover on touch, so a tap holds the row and a second tap releases.
        items.forEach((item) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            this.held === item ? this.drop() : this.lift(item);
          });
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest('[data-rev-item]')) this.drop();
        });
        return;
      }

      items.forEach((item) => {
        item.addEventListener('mouseenter', () => this.lift(item));
        item.addEventListener('mouseleave', () => this.drop());
        // Keyboard users get the same pause-and-enlarge.
        item.tabIndex = 0;
        item.addEventListener('focus', () => this.lift(item));
        item.addEventListener('blur', () => this.drop());
      });
    }
  }

  document.querySelectorAll('[data-rev]').forEach((el) => new GiftReviews(el));

  /* The form starts closed so the reviews stay the focus, and opens in place
     rather than sending anyone to another page. */
  document.querySelectorAll('[data-grev-toggle]').forEach((btn) => {
    const form = document.getElementById(btn.getAttribute('aria-controls'));
    if (!form) return;
    btn.addEventListener('click', () => {
      const open = form.hidden;
      form.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => form.querySelector('input, textarea')?.focus({ preventScroll: true }), 320);
      }
    });
  });

  /* Shopify returns to the page with ?contact_posted=true after a send. */
  if (new URLSearchParams(location.search).get('contact_posted') === 'true') {
    const form = document.querySelector('[data-grev-form]');
    const btn = document.querySelector('[data-grev-toggle]');
    if (form && btn) {
      form.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      form.scrollIntoView({ block: 'center' });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-application"] && !Shopify.designMode) return;
  try {
    
  /* Most resellers ship to the same place they bill. */
  document.querySelectorAll('[data-rsl-same]').forEach((box) => {
    const form = box.closest('form');
    const billing = form.querySelector('#rsl-billing');
    const shipping = form.querySelector('#rsl-shipping');
    if (!billing || !shipping) return;

    const mirror = () => { if (box.checked) shipping.value = billing.value; };
    box.addEventListener('change', () => {
      shipping.readOnly = box.checked;
      mirror();
      if (!box.checked) shipping.focus();
    });
    billing.addEventListener('input', mirror);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-order"] && !Shopify.designMode) return;
  try {
    
  class TradeOrderForm {
    constructor(form) {
      this.form = form;
      this.rows = Array.from(form.querySelectorAll('[data-tord-row]'));
      this.subtotalEl = form.querySelector('[data-tord-subtotal]');
      this.savingsEl = form.querySelector('[data-tord-savings]');
      this.totalEl = form.querySelector('[data-tord-total]');
      this.submit = form.querySelector('[data-tord-submit]');
      this.error = form.querySelector('[data-tord-error]');

      form.addEventListener('input', () => this.recalculate());
      form.addEventListener('submit', (e) => { e.preventDefault(); this.send(); });
      this.recalculate();
    }

    static money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
    }

    /* Two kinds of line. A per-unit line multiplies its price by the quantity
       typed. A case line is a fixed price, so the quantity is how many cases. */
    read(row) {
      const input = row.querySelector('[data-tord-qty]');
      let qty = parseInt(input.value, 10);
      if (!Number.isFinite(qty) || qty < 0) qty = 0;
      const max = parseInt(input.getAttribute('max'), 10);
      if (Number.isFinite(max) && qty > max) { qty = max; input.value = String(max); }
      return {
        input,
        qty,
        variant: row.dataset.variant,
        price: parseInt(row.dataset.price, 10) || 0,
        saving: parseInt(row.dataset.saving, 10) || 0,
      };
    }

    recalculate() {
      let subtotal = 0;
      let savings = 0;

      this.rows.forEach((row) => {
        const { qty, price, saving } = this.read(row);
        const line = price * qty;
        subtotal += line;
        savings += saving * qty;
        row.querySelector('[data-tord-line]').textContent = TradeOrderForm.money(line);
        row.classList.toggle('is-active', qty > 0);
      });

      this.subtotalEl.textContent = TradeOrderForm.money(subtotal);
      this.savingsEl.textContent = TradeOrderForm.money(savings);
      this.totalEl.textContent = TradeOrderForm.money(subtotal);
      this.submit.disabled = subtotal === 0;
    }

    async send() {
      if (this.sending) return;
      const items = this.rows.map((r) => this.read(r))
        .filter((r) => r.qty > 0)
        .map((r) => ({ id: Number(r.variant), quantity: r.qty }));
      if (!items.length) return;

      this.sending = true;
      const label = this.submit.textContent;
      this.submit.disabled = true;
      this.submit.textContent = 'One moment…';
      this.error.hidden = true;

      try {
        /* The cart is emptied first so a half-finished order left from an
           earlier visit cannot ride along to checkout. */
        await fetch(this.form.dataset.cartUpdate + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: Object.fromEntries(this.rows.map((r) => [r.dataset.variant, 0])) }),
        });

        const added = await fetch(this.form.dataset.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!added.ok) {
          const err = await added.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Sorry, that order could not be started.');
        }

        window.location.href = this.form.dataset.checkout;
      } catch (err) {
        this.sending = false;
        this.submit.disabled = false;
        this.submit.textContent = label;
        this.error.textContent = err.message;
        this.error.hidden = false;
      }
    }
  }

  document.querySelectorAll('[data-tord-form]').forEach((f) => new TradeOrderForm(f));

  /* Coming back with the browser button restores the page mid-submit. */
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('[data-tord-submit]').forEach((b) => {
      if (b.disabled && b.textContent.trim() === 'One moment…') window.location.reload();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
